import { Component, OnInit, OnDestroy } from '@angular/core';
import { process, State } from '@progress/kendo-data-query';
import { GridDataResult, DataStateChangeEvent } from '@progress/kendo-angular-grid';
import { BuilderService } from '@app/modules/builder/base';
import { SessionService, BCASearch, ConstantsService } from '@app/base/core';
import { SocoHttpService } from '@app/soco/http';
import { ActivatedRoute} from '@angular/router';
import { takeWhile } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { DatePipe } from '@angular/common';

declare var swal: any;
require('sweetalert');

@Component({
  selector: 'main-request',
  templateUrl: './main.request.component.html',
  styleUrls: ['./main.request.component.css']
})
export class MainRequestComponent implements OnInit, OnDestroy {
  public mainsData: any = [];
  public builderId: string[];
  public state: State = {
    skip: 0,
    take: 8,
    // Initial filter descriptor
    filter: {
      logic: 'and',
      filters: [
      ]
    }
  };
  // public gridData: GridDataResult = process(sampleProducts, this.state);
  public gridMains: GridDataResult = process(this.mainsData, this.state);
  public projectNumber: number;
  public projectName: string;
  public routeSubscription: any;
  public bcaDetailsSubscription: Subscription;
  public mainsInfoSubscription: Subscription;
  public stateCd: string;
  public GrId: any;
  date1 = new Date('04/09/2018');
  date2 = new Date('04/09/2019');
  public killsubscribe: boolean;
  public bcaSearch: BCASearch = {
    builderId: [],
    projectName: '',
    projectAddress: '',
    bcaStatus: '',
    subsidaryId: '',
    subsidarycompanyName: '',
    startDate: this.date1,
    endDate: this.date2,
    reqId: '',
    bcaStatusValue: ''
  };
  // Bind data to grid on data state change
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.gridMains = process(this.mainsData, this.state);
  }
  constructor(private http: BuilderService,
    public socoHttp: SocoHttpService,
    public sessionSvc: SessionService,
    public route: ActivatedRoute,
    public builderSvc: BuilderService,
    public datePipe: DatePipe,
    public constantssvc: ConstantsService) {
    }
  ngOnInit() {
    this.killsubscribe = true;
    this.stateCd = this.sessionSvc.paramLdc;
    this.GrId = this.route.snapshot.parent.params['id'];
    // Getting project details like project number,project status
    this.sessionSvc.BcaData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
       if (success) {
        this.sessionSvc.GridData.subscribe(success => {
          this.projectNumber = success.projectNumber;
          this.projectName = success.projectName;
        });
      } else {
        this.sessionSvc.builderData.pipe(takeWhile(() => this.killsubscribe)).subscribe(success => {
         if (success) {
          this.builderId = success.BuilderId;
          for (let i = 0; i < this.builderId.length; i++) {
            this.bcaSearch.builderId.push(this.builderId[i]);
          }
        this.bcaSearch.reqId = this.GrId;
        this.bcaDetailsSubscription = this.builderSvc.getBuilderBCADetails(this.bcaSearch).subscribe(result => {
          if (result.data[0].bcaId !== undefined) {
            this.projectNumber = result.data[0].bcaId;
          }
          this.projectName = result.data[0].projectName;
        });
      }
    });
  }
});
    this.loadMains();
  }
// To get gas mains data
  loadMains() {
      const wrTypeCodes = ['CINBE', 'RNBE', 'SRNBE', 'MLTFM'];
         this.socoHttp.showPleaseWait('Processing', 'mains');
         this.mainsInfoSubscription = this.http.getMainsInfo(this.GrId).subscribe(
       result => {
         if (result) {
           for (let i = 0; i < result.data.length; i++) {
             if ((result.data[i]['wrNo'] != null) && wrTypeCodes.includes(result.data[i]['wrTypeCode'])) {
                this.mainsData.push(result.data[i]);
             }
           }
           this.gridMains = process(this.mainsData, this.state);
         }
         this.socoHttp.hidePleaseWait('mains');
       },
       error => {
        swal(this.constantssvc.errorSwal1, this.constantssvc.mainsFail, this.constantssvc.errorSwal);
       }
     );
  }
  // export to excel and pdf disable
  checkExport(): boolean {
    if (this.mainsData.length === 0) {
      return true;
    } else {
      return false;
    }
  }
  // ondestroy
  ngOnDestroy() {
    this.killsubscribe = false;
    if (this.mainsInfoSubscription) {
    this.mainsInfoSubscription.unsubscribe();
    }
    if (this.bcaDetailsSubscription) {
           this.bcaDetailsSubscription.unsubscribe();
    }
  }

}
